import { FC } from 'react';

const DEIcon: FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="none"
    >
      <path
        d="M0.746094 16.1749C2.44161 20.7445 6.84012 24.001 11.9997 24.001C17.1593 24.001 21.5578 20.7445 23.2533 16.1749L11.9997 15.1315L0.746094 16.1749Z"
        fill="#FFDA44"
      />
      <path
        d="M11.9997 0.000793457C6.84012 0.000793457 2.44161 3.25729 0.746094 7.8269L11.9997 8.87034L23.2533 7.82686C21.5578 3.25729 17.1593 0.000793457 11.9997 0.000793457Z"
        fill="black"
      />
      <path
        d="M0.746391 7.82574C0.264047 9.12573 0 10.5318 0 11.9996C0 13.4675 0.264047 14.8735 0.746391 16.1735H23.2537C23.736 14.8735 24 13.4675 24 11.9996C24 10.5318 23.736 9.12573 23.2536 7.82574H0.746391Z"
        fill="#D80027"
      />
    </svg>
  );
};

export default DEIcon;
